<template>
    <div class="about">
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">
                        Badge Identifier
                    </th>
                    <th class="text-left">
                        Achieved Date
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="item in badges"
                        :key="item.identifier"
                >
                    <td>{{ item.identifier }}</td>
                    <td>{{ item.lastAchievedDate }}</td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>


<script>
    import constants from "../../constants";

    export default {
        methods: {
            loadData() {
                this.$http.get(constants.BADGES_ENDPOINT, {
                    params: {
                        accId: this.user.id
                    }
                })
                    .then((response) => {
                        console.log(response)
                        this.badges = response.data.badges
                    })
                    .catch(error => {
                        console.log(error)
                        //this.$log.error('Error in getting template ids: ', error)
                    });
            }
        },
        data() {
            return {
                badges: null
            }
        },
        mounted() {
            this.loadData()
        },
        props: ['user'],
    };
</script>
